import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import "react";
import { A } from "../A/index.js";
import { Button } from "../Button/index.js";
import { P } from "../Text/index.js";
import { stickyActionBar } from "./StickyActionBar.variants.js";
function StickyActionBar({ children, headerContent, actionText, helperText, isLink = false, url, type = 'primary', onClick, secondaryActionText, secondaryOnClick, barType }) {
    const hasSecondaryAction = Boolean(secondaryActionText) && 'actionBar' === barType;
    const { root, mainContainer, textContainer, actionContainer, headerContainer, helperTextSlot, primaryActionContainer, secondaryActionContainer } = stickyActionBar({
        barType,
        hasSecondaryAction,
        type
    });
    const renderPrimaryAction = ()=>{
        const className = 'w-full';
        return isLink ? /*#__PURE__*/ jsx(A, {
            href: url,
            type: type ?? 'primaryShop',
            className: className,
            size: "lg",
            shadow: true,
            children: actionText
        }) : /*#__PURE__*/ jsx(Button, {
            type: type ?? 'primary',
            className: className,
            size: "lg",
            shadow: true,
            onClick: onClick,
            children: actionText
        });
    };
    const renderSecondaryAction = ()=>{
        if (!hasSecondaryAction) return null;
        const className = 'w-full';
        return /*#__PURE__*/ jsx(Button, {
            type: "tertiary",
            size: "lg",
            className: className,
            onClick: secondaryOnClick,
            children: secondaryActionText
        });
    };
    return /*#__PURE__*/ jsxs("div", {
        className: root(),
        children: [
            headerContent && /*#__PURE__*/ jsx("div", {
                className: headerContainer(),
                children: headerContent
            }),
            /*#__PURE__*/ jsxs("div", {
                className: "px-4 pb-2 pt-4",
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: mainContainer(),
                        children: [
                            children && 'bookBar' === barType && /*#__PURE__*/ jsx("div", {
                                className: textContainer(),
                                children: children
                            }),
                            /*#__PURE__*/ jsx("div", {
                                className: actionContainer(),
                                children: hasSecondaryAction ? /*#__PURE__*/ jsxs(Fragment, {
                                    children: [
                                        /*#__PURE__*/ jsx("div", {
                                            className: secondaryActionContainer(),
                                            children: renderSecondaryAction()
                                        }),
                                        /*#__PURE__*/ jsx("div", {
                                            className: primaryActionContainer(),
                                            children: renderPrimaryAction()
                                        })
                                    ]
                                }) : renderPrimaryAction()
                            })
                        ]
                    }),
                    helperText && /*#__PURE__*/ jsx(P, {
                        className: helperTextSlot(),
                        palette: "neutral",
                        shade: "13",
                        children: helperText
                    })
                ]
            })
        ]
    });
}
export { StickyActionBar };
